
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
  },
  watch: {
    $route: {
      handler: async function(to, from) {
        await (this as any).init();
      },
    },
  },
})
export default class Claims extends Vue {
  dictionary: any = {};
  title: string = "";
  filter: any = {
    controlZoneId: "",
    year: "",
    reporttype: "",
    branchId: "",
    trimester: "",
    status_client: "",
    status_admin: "",
    claimCode: "",
    requestCode: "",
    claimNumber: "",
    requestNumber: "",
    seguredName: "",
    policy_number: "",
  };
  currentClaim: number = 0;
  claims: any = [];
  controlzones: any = [];
  branches: any = [];
  statuses: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  companyId: number = 0;
  sortColumns: Record<string, string> = {
    name: "Empresa",
    owner: "Responsable",
    deletedAt: "Estado",
  };
  currentSort: Record<string, string> = {
    col: "claims.order",
    dir: "asc",
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadBranches();
    await this.init();
  }

  async init() {
    this.title = "Listado de Siniestros";
    await this.loadControlZones();
    await this.loadTrimesters();
    await this.loadStatuses();
    await (this as any).loadClaims(1, this.currentSort);
  }

  showDeleteModal(id: number) {
    this.currentClaim = id;
    (this.$refs.modal as any).show();
  }

  async clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      this.filter[key] = "";
    });
    await (this as any).loadClaims(1, this.currentSort);
  }
  branch(id) {
    let branch: any[] = this.branches.filter((branch) => branch.id === id);
    return branch[0].title;
  }
  momentify(date) {
    let formattedDate: any = "";
    if (date) formattedDate = moment(date).format("DD/MM/YYYY");
    return formattedDate;
  }
  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    if (status === 8) return "pendingForEndorsement";
    return "inactive";
  }

  async onPageChange(page: number, limit: number) {
    this.limit = limit;
    await (this as any).loadClaims(page, this.currentSort);
  }

  async loadClaims(
    page: number,
    sort: Record<string, string>,
    showPopup: boolean
  ) {
    this.currentSort = sort;
    this.filter.companyId = this.companyId;
    this.filter.controlZoneId =
      this.filter.controlZoneId === "NULL" ? null : this.filter.controlZoneId;
    const response: any = await (this.$root as any)._post("claims/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      ...this.filter,
    });
    this.totalRows = response.totalRows;
    this.claims = response.data;
    if (showPopup)
      (this.$root as any).notify("Busqueda realizada con éxito!", "success");
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadControlZones() {
    const user: any = await (this.$root as any)._post(
      `subscriptors/one/${this.$store.state.user.id}`,
      {
        models: "companies",
      }
    );
    const company: any = user.data[0].companies[0];
    const response: any = await (this.$root as any)._post("controlzones/all", {
      countryId: company.countryId,
    });
    this.controlzones = response.data;
    if (this.$store.state.companyId) {
      this.companyId = this.$store.state.companyId;
    } else {
      this.companyId = company.id;
    }
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get("requests/trimesters");
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }
}
